import AudiencePage from "../components/marketing/AudiencePage";
import { SHOTS } from "../components/marketing/features";

const STEPS = [
  { title: "See what's next and RSVP", tier: "free", shot: SHOTS.clipboard,
    body: "Join from the coach's invite or the team join code. Your Clipboard shows each kid's upcoming events across every team, with one-tap Going or Can't go. Cancellations and delays show as a banner at the top and arrive by push and email. If the coach changes several events at once, you get one combined alert." },
  { title: "Read every team update", tier: "free", shot: SHOTS.talkParent,
    body: "Chalk Talk keeps coach announcements in one feed. Free accounts see the last 30 days. The Clipboard+ keeps the full history." },
];

export default function Parents() {
  return (
    <AudiencePage
      id="parents" docTitle="Chalk OS for parents: every kid, every team, one app"
      eyebrow="For parents & guardians" title="Every kid. Every team." marker="One app."
      intro="Stop digging through group texts. See tonight's plan, RSVP in one tap and get alerts when the field moves."
      steps={STEPS} featureTitle="What families get." featureSub="Free for every family on a team."
      features={["clipboard", "rsvp", "alerts", "reminders", "claimDuties", "history30",
                 "familyDashboard", "familyConflicts", "fullHistory", "calendar", "manualTeams", "alertControls"]}
    />
  );
}
